import { ActivityIcon, ClockIcon, ImagesIcon, SquareDashedIcon, TagIcon, UploadIcon } from '@air/design-icons';

import { Pathnames } from '~/components/v2/constants/pathnames';

export type SearchNavItemTrackingId =
  | 'search'
  | 'recently_added'
  | 'my_uploads'
  | 'my_favorites'
  | 'recently_modified'
  | 'unused_items'
  | 'untagged_items';

export type SearchNavIcon = typeof ImagesIcon;

export type SearchNavItem = {
  href: Pathnames;
  icon: SearchNavIcon;
  id: string;
  label: string;
  trackingId: SearchNavItemTrackingId;
};

export const FAVORITED_ASSETS_NAV_ITEM: SearchNavItem = {
  href: Pathnames.FavoriteItems,
  icon: ImagesIcon,
  id: 'my-favorites',
  label: 'Favorited assets',
  trackingId: 'my_favorites',
};

export const SEARCH_NAV_ITEMS: SearchNavItem[] = [
  {
    href: Pathnames.Search,
    icon: ImagesIcon,
    id: 'all-assets',
    label: 'All Assets & Files',
    trackingId: 'search',
  },
  {
    href: Pathnames.RecentlyAdded,
    icon: ClockIcon,
    id: 'recently-added',
    label: 'Recently Added',
    trackingId: 'recently_added',
  },
  {
    href: Pathnames.MyUploads,
    icon: UploadIcon,
    id: 'my-uploads',
    label: 'My Uploads',
    trackingId: 'my_uploads',
  },
  FAVORITED_ASSETS_NAV_ITEM,
  {
    href: Pathnames.RecentlyModified,
    icon: ActivityIcon,
    id: 'recently-modified',
    label: 'Recently Modified',
    trackingId: 'recently_modified',
  },
  {
    href: Pathnames.UnusedItems,
    icon: SquareDashedIcon,
    id: 'unused-items',
    label: 'Unused Items',
    trackingId: 'unused_items',
  },
  {
    href: Pathnames.UntaggedItems,
    icon: TagIcon,
    id: 'untagged-items',
    label: 'Untagged Items',
    trackingId: 'untagged_items',
  },
];

/** Fast filters inside Search all. Favorited assets lives under Favorites. */
export const SEARCH_NESTED_NAV_ITEMS = SEARCH_NAV_ITEMS.filter(
  (item) => item.id !== 'all-assets' && item.id !== FAVORITED_ASSETS_NAV_ITEM.id,
);

export const SAVED_SEARCH_LIST_LIMIT = 100;
export const SAVED_SEARCH_SKELETON_COUNT = 4;
